import React, { useState } from "react";
import styles from "./subMenuLink.module.scss";
import { Link as NavLink, useLocation } from "react-router-dom";
import { Tooltip } from "antd";
import IconOutline from "src/assets/icons/new-outline-info.svg?react";
import { LordIcon } from "../../lord-icon/lord-icon";
import { IconInfo } from "@constants";

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  to?: string;
  iconUrl?: string;
  href?: string;
  target?: string;
  title?: string;
  tooltipTitle?: string;
  tooltipContent?: string;
  onClick?: (e?: any) => void;
  className?: string;
  comingSoon?: boolean;
  onMouseOver?: (e?: any) => void;
  onMouseLeave?: (e?: any) => void;
};

const colors = { primary: "#FFB073", secondary: "#6C969A" };

function SubMenuLink({
  to,
  iconUrl,
  href,
  target,
  title,
  tooltipTitle,
  tooltipContent,
  onClick,
  onMouseOver,
  onMouseLeave,
  className,
  comingSoon = false,
}: Props) {
  const { pathname } = useLocation();
  const [isHover, setIsHover] = useState(false);
  const active = pathname === to;

  const hasLineBreaks = title && (title.includes("\n") || title.includes("\\n"));

  const renderTitle = () => {
    if (!title) return null;
    if (title.includes("\n") || title.includes("\\n")) {
      const parts = title.split(/\n|\\n/);
      return (
        <>
          {parts.map((part, index) => (
            <React.Fragment key={index}>
              {part}
              {index < parts.length - 1 && <br />}
            </React.Fragment>
          ))}
        </>
      );
    }
    return title;
  };

  return (
    <div className={styles.menuWrapper}>
      {!!href ? (
        <a
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${className || ""
            }`}
          href={href}
          target={target}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
        >
          {iconUrl && <div className={styles.menuLeftIcon}>
            <LordIcon
              src={iconUrl}
              isHover={isHover}
              target=".ant-menu-item"
            />
          </div>}
          <div
            className={styles.menuItemSubTitle}
            style={hasLineBreaks ? { lineHeight: '18px' } : undefined}
          >
            {renderTitle()}
          </div>
        </a>
      ) : !!to ? (
        <NavLink
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${className || ""
            }`}
          to={to || ""}
          onMouseOver={() => { setIsHover(true) }}
          onMouseLeave={() => { setIsHover(false) }}
        >
          <div className={styles.menuItemContent}>
            {iconUrl && <div className={styles.menuLeftIcon}>
              <LordIcon
                src={iconUrl}
                isHover={isHover}
                target=".ant-menu-item"
              />
            </div>}
            <div
              className={styles.menuItemSubTitle}
              style={hasLineBreaks ? { lineHeight: '18px' } : undefined}
            >
              {renderTitle()}
            </div>
          </div>
          {
            tooltipTitle && (
              <Tooltip
                placement="rightTop"
                title={
                  <div className={styles.cardBack}>
                    <IconOutline className={styles.infoicon} />
                    <div className={styles.hoverCardText}>
                      <div className={styles.span1}>
                        {tooltipTitle}
                      </div>
                      {tooltipContent && <div className={styles.span2}>
                        <strong>Hint: </strong>{tooltipContent}
                      </div>}
                    </div>
                  </div>
                }
                overlayStyle={{ maxWidth: "400px" }}
                showArrow={false}
                color="#FFFFFF"
              >
                <div className={styles.menuRightIcon}>
                  {
                    <LordIcon
                      size={30}
                      src={IconInfo}
                      isHover={isHover}
                      colors={colors}
                      mainColor="#6C959A"
                    />
                  }
                </div>
              </Tooltip>
            )
          }
        </NavLink>
      ) : (
        <div
          onClick={onClick}
          className={`${styles.container} ${active ? styles.active : ""} ${className || ""
            }`}
          onMouseOver={() => { setIsHover(true) }}
          onMouseLeave={() => { setIsHover(false) }}
          style={{ cursor: comingSoon ? "default" : "pointer" }}
        >
          <div className={styles.menuItemContent}>
            {iconUrl && <div className={styles.menuLeftIcon}>
              <LordIcon
                src={iconUrl}
                isHover={isHover}
                target=".ant-menu-item"
              />
            </div>}
            <div
              className={styles.menuItemSubTitle}
              style={hasLineBreaks ? { lineHeight: '18px' } : undefined}
            >
              {renderTitle()}
            </div>
          </div>
          {
            tooltipTitle && (
              <Tooltip
                placement="rightTop"
                title={
                  <div className={styles.cardBack}>
                    <IconOutline className={styles.infoicon} />
                    <div className={styles.hoverCardText}>
                      <div className={styles.span1}>
                        {tooltipTitle}
                      </div>
                      {tooltipContent && <div className={styles.span2}>
                        <strong>Hint: </strong>{tooltipContent}
                      </div>}
                    </div>
                  </div>
                }
                overlayStyle={{ maxWidth: "400px" }}
                showArrow={false}
                color="#FFFFFF"
              >
                <div className={styles.menuRightIcon}>
                  {
                    <LordIcon
                      size={30}
                      src={IconInfo}
                      isHover={isHover}
                      colors={colors}
                      mainColor="#6C959A"
                    />
                  }
                </div>
              </Tooltip>
            )
          }
        </div>
      )}
    </div>
  );
}

export default SubMenuLink;
